import React from 'react';
import Landmark from '@core/scripts/components/landmark-adapter';
import WindowManager from '@core/scripts/components/window-manager';
import ProductCard, {Touchpoint} from '@shopping-funnel/scripts/components/product-card/ProductCard.jsx';
import MessageBroker from 'deprecated-shared-ui/components/message-broker';
import Messages from '@shopping-funnel/scripts/components/messages';
import WishlistMessages from '@shopping-funnel/scripts/components/messages';

const State = {
    DEFAULT: 'default',
    REMIND_ME: 'remind me',
    SOLD_OUT: 'sold out'
};

export default function WishlistItem({
                                         item,
                                         texts,
                                         opacity,
                                         pointOfSaleId,
                                         setSimilarArticlesSheetOpen,
                                         setSelectedWishlistItem
                                     }) {

    const disabled = opacity < 1.0;

    const itemState =
        item.buyable ?
            State.DEFAULT :
            item.productCardItem.soldOut ?
                State.SOLD_OUT :
                State.REMIND_ME;


    const onItemClick = () => {
        Landmark.sendClickLandmark('wl_ada');
        WindowManager.setSpecificTabDataItem('pointOfSaleId', pointOfSaleId);
    };

    const showErrorLayer = () => {
        window.dispatchEvent(new CustomEvent('wishlist-error-modal:open', {
            detail: {
                error: 'ERROR'
            }
        }));
    };

    const handleBuyClick = async () => {
        if (disabled) return;
        Landmark.sendClickLandmark('wl_kaufen');

        // Das AddItemToCartSheet entscheidet selbst, ob es bei vollständiger, kaufbarer Vorauswahl
        // direkt in den Warenkorb legt (und das Erfolgs-Sheet zeigt) oder die Auswahl anzeigt.
        MessageBroker.publish(WishlistMessages.WISHLIST.OPEN_CHANGE_ITEM_ONSITE_ELEMENT, {
            styleId: item.digistyleId,
            itemId: item.itemId,
            itemOptionId: item.productCardItem.itemOptionId ?? '',
            shopId: item.shopId,
            wishlistItemId: item.wishlistItemId,
            pointOfSaleId: pointOfSaleId,
            algoliaQueryId: item.algoliaQueryId,
        });
    };

    const handleNotifyClick = () => {
        MessageBroker.publish(Messages.CHANGE_ITEM_LAYER_DATA, {
            item: item,
            itemOptionId: item.productCardItem?.itemOptionId,
            notifiable: item.notifiable,
            origin: 'wishlist'
        });
    };

    const handleSelectSizeClick = () => {
        Landmark.sendClickLandmark('wl_select_size');
        MessageBroker.publish(WishlistMessages.WISHLIST.OPEN_CHANGE_ITEM_ONSITE_ELEMENT, {
            styleId: item.digistyleId,
            itemId: item.itemId,
            itemOptionId: item.productCardItem.itemOptionId ?? '',
            shopId: item.shopId,
            wishlistItemId: item.wishlistItemId,
            pointOfSaleId: pointOfSaleId,
            algoliaQueryId: item.algoliaQueryId,
        });
    };

    const handleSimilarArticlesClick = (item) => {
        setSimilarArticlesSheetOpen(true);
        setSelectedWishlistItem(item);
    };

    let primaryButton;
    if (itemState === State.DEFAULT) {
        primaryButton = (
            <ProductCard.PrimaryButton
                arialabel={texts.pc_aria_into_cart_button}
                icon="cart"
                clickHandler={handleBuyClick}
            />
        );

    } else if (itemState === State.REMIND_ME) {
        primaryButton = (
            <ProductCard.PrimaryButton
                arialabel={texts.pc_aria_remind_me_button}
                icon="bell"
                clickHandler={handleNotifyClick}
                linktext={texts.product_card_notify_by_mail}
            />
        );

    } else if (itemState === State.SOLD_OUT) {
        primaryButton = (
            <ProductCard.PrimaryButton
                arialabel={texts.pc_aria_show_similar_articles_button}
                icon="similar-products"
                clickHandler={() => {
                    handleSimilarArticlesClick(item);
                }}
                linktext={texts.wishlist_similar_articles_headline}
            />
        );
    }

    return (
        <>
            <div className="wishlist-item" style={{opacity: opacity}}>
                <ProductCard
                    item={item.productCardItem}
                    texts={texts}
                    touchpoint={Touchpoint.WISHLIST}
                    isSoldOut={itemState === State.SOLD_OUT}
                    onItemClick={onItemClick}
                    handleSelectSizeClick={handleSelectSizeClick}
                    useDesyPriceComponent={true}
                    imageContainerClassName="aspect-[5/7]"
                >
                    {primaryButton}
                </ProductCard>
            </div>
        </>
    );
}
